import React from 'react';

/**
 * Componente Spinner com símbolo $ girando
 * Usa as cores do tema (azul/indigo) para combinar com o site
 */
export function Spinner({ size = 'md', className = '' }) {
  const sizes = {
    sm: 'w-8 h-8 text-2xl',
    md: 'w-16 h-16 text-5xl',
    lg: 'w-24 h-24 text-7xl',
    xl: 'w-32 h-32 text-9xl'
  };

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <div
        className={`${sizes[size]} font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 animate-spin`}
        style={{
          animationDuration: '1s'
        }}
      >
        $
      </div>
    </div>
  );
}

/**
 * Spinner com texto de loading
 */
export function SpinnerWithText({ text = 'Carregando...', size = 'md' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <Spinner size={size} />
      <p className="text-slate-600 font-medium">{text}</p>
    </div>
  );
}

/**
 * Loading Overlay - Cobre a tela inteira
 */
export function LoadingOverlay({ text = 'Carregando...', show = true }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 flex flex-col items-center gap-4 border border-slate-200">
        <Spinner size="lg" />
        <p className="text-slate-700 font-semibold text-lg">{text}</p>
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}

/**
 * Loading inline - Para usar dentro de cards/containers
 */
export function LoadingInline({ text = 'Carregando...', size = 'sm' }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 gap-3">
      <Spinner size={size} />
      <p className="text-slate-500 text-sm">{text}</p>
    </div>
  );
}
